import { useState } from "react";
import { faqs } from "@/mocks/scandal";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section className="bg-background-100/50">
      <div className="mx-auto max-w-6xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-10">
          <div className="lg:col-span-4">
            <div className="flex items-center gap-2">
              <span className="inline-block h-4 w-1.5 rounded-sm bg-accent-500" />
              <span className="text-xs font-bold uppercase tracking-widest text-accent-600">Quick Guide</span>
            </div>
            <h2 className="font-heading mt-2 text-2xl font-black text-foreground-950 md:text-3xl">关于这套档案的常见疑问</h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              还没搞懂「抖音黑料前因后果」怎么组织的，先看这几点，其余信息在主时间线与资源区都能找到。
            </p>
            <a
              href="#top"
              className="mt-5 inline-flex items-center gap-1.5 rounded-md bg-primary-600 px-4 py-2 text-sm font-semibold text-background-50 whitespace-nowrap hover:bg-primary-700"
            >
              回到顶部
              <i className="ri-arrow-up-line" />
            </a>
          </div>

          <div className="lg:col-span-8">
            <div className="divide-y divide-background-200 rounded-lg border border-background-200 bg-background-50">
              {faqs.map((f, i) => {
                const open = openIdx === i;
                return (
                  <button
                    key={f.q}
                    type="button"
                    onClick={() => setOpenIdx(open ? -1 : i)}
                    className="flex w-full flex-col items-start gap-2 px-4 py-4 text-left md:px-5"
                  >
                    <span className="flex w-full items-center justify-between gap-4">
                      <span className="text-[15px] font-bold text-foreground-900">{f.q}</span>
                      <i className={`text-xl text-accent-600 transition-transform ${open ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"}`} />
                    </span>
                    {open && <span className="text-sm leading-relaxed text-foreground-600">{f.a}</span>}
                  </button>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}